<template>
  <div class="ui--content-heading">
    <strong class="navbar-brand">{{title}}</strong>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb float-right">
          <li v-for="(item, index) in breadcrumb" :key="index" class="breadcrumb-item" :class='{"active": item.active}'>
            <a href="#">{{item.text}}</a>
          </li>
        </ol>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'PubBreadcrumb',
  props: {
    breadcrumb: {
      type: Array,
      default: () => [],
    },
    title: {
      type:String,
      default:'타이틀',
    }
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/markup/components/PubBreadcrumb.vue